import { render } from "./ReportPdp.vue?vue&type=template&id=1af74e31&scoped=true"
import script from "./ReportPdp.vue?vue&type=script&lang=js"
export * from "./ReportPdp.vue?vue&type=script&lang=js"

import "./ReportPdp.vue?vue&type=style&index=0&id=1af74e31&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af74e31"]])

export default __exports__